
export default function FlagVN({
  width = 16,
  height = 16
}) {
  return (
    <svg 
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlnsXlink="http://www.w3.org/1999/xlink" 
      x="0px" y="0px" 
      width={width} height={height} 
      viewBox="0 0 800 800" 
      enableBackground="new 0 0 800 800" 
      xmlSpace="preserve">
      <g>
        <path fill="#ED1F34" d="M24.807,646.161v-91.322c0-6.563-5.34-11.903-11.903-11.903h-1v-27.807h1
		c6.563,0,11.903-5.34,11.903-11.903V153.839h750.387v492.322H24.807z M477.358,539.011c1.935,1.259,4.18,1.925,6.492,1.925
		c2.528,0,4.947-0.787,6.995-2.274c3.964-2.88,5.772-7.99,4.5-12.719l-23.952-89.123l71.763-58.024
		c3.808-3.078,5.349-8.275,3.836-12.933c-1.513-4.659-5.815-7.958-10.707-8.21l-92.16-4.761l-33.009-86.18
		c-1.751-4.573-6.219-7.645-11.116-7.645c-4.898,0-9.365,3.072-11.116,7.645l-33.009,86.18l-92.161,4.761
		c-4.891,0.252-9.193,3.552-10.707,8.21c-1.513,4.658,0.028,9.855,3.836,12.933l71.763,58.024l-23.952,89.123
		c-1.272,4.729,0.536,9.84,4.5,12.718c2.048,1.487,4.468,2.273,6.998,2.273c2.309,0,4.553-0.665,6.49-1.924L400,488.69
		L477.358,539.011z" />
        <path fill="#ED1F34" d="M25.807,554.839v90.322h748.387V154.839H25.807v348.387c0,7.128-5.776,12.903-12.903,12.903v25.807
		C20.031,541.936,25.807,547.711,25.807,554.839z M252.057,365.554c1.652-5.084,6.268-8.625,11.606-8.9l91.511-4.728l32.776-85.572
		c1.911-4.991,6.703-8.287,12.05-8.287s10.139,3.296,12.05,8.287l32.776,85.572l91.511,4.728c5.341,0.275,9.955,3.816,11.606,8.9
		c1.651,5.083-0.002,10.66-4.158,14.02l-71.257,57.614l23.783,88.495c1.389,5.161-0.553,10.646-4.878,13.787
		c-2.257,1.64-4.917,2.466-7.583,2.466c-2.445,0-4.894-0.691-7.037-2.087L400,489.884l-76.813,49.965
		c-4.483,2.913-10.295,2.763-14.62-0.379c-4.325-3.141-6.267-8.626-4.878-13.787l23.783-88.495l-71.257-57.614
		C252.059,376.213,250.405,370.637,252.057,365.554z" />
        <path d="M787.097,129.032H12.903C5.775,129.032,0,134.808,0,141.936v361.29c0,7.128,5.775,12.903,12.903,12.903
		c7.127,0,12.903-5.775,12.903-12.903V154.839h748.387v490.322H25.807v-90.322c0-7.128-5.776-12.903-12.903-12.903
		C5.775,541.936,0,547.711,0,554.839v103.226c0,7.128,5.775,12.903,12.903,12.903h774.193c7.128,0,12.903-5.775,12.903-12.903
		V141.936C800,134.808,794.225,129.032,787.097,129.032z" />
        <path fill="#FFE000" d="M406.49,464.513c-1.936-1.259-4.181-1.925-6.492-1.925c-2.311,0-4.555,0.666-6.491,1.925l-57.798,37.596
		l17.896-66.588c1.222-4.542-0.353-9.388-4.01-12.345l-53.616-43.352l68.857-3.557c4.697-0.244,8.82-3.239,10.501-7.631L400,304.248
		l24.658,64.39c1.682,4.393,5.805,7.388,10.503,7.63l68.857,3.557l-53.616,43.352c-3.657,2.958-5.231,7.803-4.011,12.345
		l17.896,66.588L406.49,464.513z" />
        <path fill="#FFE000" d="M350.223,422.398c3.969,3.208,5.673,8.454,4.348,13.382l-17.218,64.066l55.609-36.172
		c2.139-1.392,4.588-2.087,7.036-2.087s4.898,0.695,7.037,2.087l55.609,36.172l-17.219-64.066
		c-1.324-4.928,0.381-10.174,4.348-13.382l51.586-41.71l-66.25-3.422c-5.098-0.263-9.561-3.506-11.385-8.271L400,307.043
		l-23.729,61.951c-1.825,4.765-6.286,8.007-11.384,8.271l-66.25,3.422L350.223,422.398z" />
        <path d="M256.215,379.573l71.257,57.614l-23.783,88.495c-1.389,5.161,0.553,10.646,4.878,13.787s10.137,3.292,14.62,0.379
		L400,489.884l76.813,49.965c2.144,1.396,4.592,2.087,7.037,2.087c2.666,0,5.328-0.824,7.583-2.466
		c4.325-3.141,6.267-8.626,4.878-13.787l-23.783-88.495l71.257-57.614c4.156-3.36,5.81-8.936,4.158-14.02
		c-1.651-5.084-6.268-8.625-11.606-8.9l-91.511-4.728l-32.776-85.572c-1.911-4.991-6.703-8.287-12.05-8.287
		s-10.139,3.296-12.05,8.287l-32.776,85.572l-91.511,4.728c-5.34,0.275-9.954,3.816-11.606,8.9
		C250.405,370.637,252.059,376.213,256.215,379.573z M376.271,368.995L400,307.043l23.729,61.951
		c1.825,4.765,6.286,8.007,11.384,8.271l66.25,3.422l-51.585,41.71c-3.969,3.208-5.673,8.454-4.348,13.382l17.218,64.066
		l-55.609-36.172c-2.139-1.392-4.588-2.087-7.036-2.087s-4.898,0.695-7.037,2.087l-55.609,36.172l17.219-64.066
		c1.324-4.928-0.381-10.174-4.348-13.382l-51.586-41.71l66.251-3.422C369.985,377.001,374.446,373.758,376.271,368.995z" />
      </g>
    </svg>
  )
}